import styled from 'styled-components';

export const Container = styled.div`
  width: 27.5rem;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  align-items: center;
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding-top: 1.875rem;
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: #585e66;
  padding-top: 0.9375rem;
`;

export const FlowName = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.875rem;
  color: #585e66;
  padding-top: 3.3125rem;
  text-align: center;
`;

export const Footer = styled.div`
  padding: 4.1875rem 0 1.875rem 0;
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
